import productsLoading from '~/marketplace-front-core/middleware/productsLoading'

export default productsLoading
